import React from 'react'
import { defaultMenuRenderer } from 'react-select'
import { Separator, SupportText } from './index.style'

const MenuRenderer = props => {
  return (
    <div>
      {defaultMenuRenderer(props)}
      <Separator />
      <SupportText>
        Need a different setup? Reach out to your Account Manager
      </SupportText>
    </div>
  )
}

export default MenuRenderer



// WEBPACK FOOTER //
// ./src/components/PollForm/VerticalTargeting/MenuRenderer.js